import React from 'react'
import { Route } from 'react-router-dom'
import Profile from './Profile'
import EditProfile from './EditProfile'
import ProtectedRoute from '../../internal/ProtectedRoute'
import { Authorities } from '../../models/authorities'
import { Roles } from '../../models/roles'
import ChangeUserView from './ChangeUserView'

const ProfileRoute = () => (
  <div>
    <Route
      key="/edit-profile"
      path="/edit-profile"
      render={() => <EditProfile />}
    />
    <ProtectedRoute
      key="/profile"
      path="/profile"
      authority={Authorities.CHANGE_USER_PROPERTIES}
      page={<Profile />}
    />
    <ProtectedRoute
      key="/change-user-view"
      path="/change-user-view"
      role={Roles.RESURS_ADMIN}
      page={<ChangeUserView />}
    />
  </div>
)

export default ProfileRoute
